"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToExplorer = redirectToExplorer;
exports.redirectToQueryParam = redirectToQueryParam;
var validateRedirectUrl = function validateRedirectUrl(redirect) {
  if (redirect.startsWith('/')) {
    window.location = decodeURIComponent(redirect);
    return true;
  } else {
    var decodedRedirect = decodeURIComponent(redirect);
    try {
      var redirectUrl = new URL(decodedRedirect, window.location.origin);
      if (redirectUrl.origin === window.location.origin) {
        window.location = redirectUrl.href;
        return true;
      }
    } catch (e) {
      console.error('Invalid URL:', e);
    }
  }
};
function redirectToQueryParam(_ref) {
  var _router$queryParams;
  var router = _ref.router,
    cms = _ref.cms;
  var redirect = (_router$queryParams = router.queryParams) === null || _router$queryParams === void 0 ? void 0 : _router$queryParams.redirect;
  if (redirect) {
    if (cms) {
      validateRedirectUrl(redirect.replace('organization-login', ''));
    } else {
      validateRedirectUrl(redirect);
    }
  }
}
function redirectToExplorer(router, views) {
  router.goTo(views.explorer, {});
}
//# sourceMappingURL=redirection.js.map